import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getOnpremHostname } from 'omni-package-react-core';
import Configuration from '../../../utils/Configuration';
import { getLanguage } from '../../../utils/getLanguage';
import { WidgetGlobalStyles } from './SignIn.styles';
import { getSignInConfiguration } from './getSignInConfiguration';

export interface SignInProps {
  mobileDeviceMode: Boolean;
  title: String;
  StyledInstabilityMessagesID: String;
  StyledInformativeMessageID: String;
  StyledTitleId: String;
  disableSignUp?: boolean;
  showRememberMe: boolean;
}

const SignIn: FC<SignInProps> = ({ mobileDeviceMode, title, StyledInstabilityMessagesID, StyledInformativeMessageID, StyledTitleId, disableSignUp = false, showRememberMe }) => {
  const { t } = useTranslation('LoginPageV2');
  const config = getSignInConfiguration(t, mobileDeviceMode, disableSignUp);
  const configApp = Configuration.Current();
  const showRememberMeDisplay = showRememberMe ? 'block' : 'none';

  React.useEffect(() => {
    const innerScript = `
    function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });

          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }


    function SetExperienceAndMobileDeviceMode() {
      let needReload = false;
      const dealersExperiences = {
        ia: 'ia',
        bnt: 'bnt',
        designSystem: 'designSystem',
        investia: 'investia',
        'Extranet Dealers Hyundai - Siteminder': 'hyundai',
        'Extranet Dealers Hyundai Mobile - Siteminder': 'hyundai',
        'Extranet Dealers Unifi - Siteminder': 'unifi',
        'Extranet Dealers Unifi Mobile - Siteminder': 'unifi',
        'Extranet Dealers Honda - Siteminder' : 'honda',
        'Extranet Dealers Honda Mobile - Siteminder': 'honda',
        'Extranet Dealers Acura - Siteminder': 'acura',
        'Extranet Dealers Acura Mobile - Siteminder': 'acura',
        'Extranet Dealers Genesis - Siteminder': 'genesis',
        'Extranet Dealers Genesis Mobile - Siteminder': 'genesis',
      };
      const dealersExperience = sessionStorage.getItem('dealersExperience') ;
      if (dealersExperience == null && oktaData.requestContext && oktaData.requestContext.app != undefined) {
          const clientLabel = oktaData.requestContext.app.value.label;
          if (dealersExperiences[clientLabel]) {
            sessionStorage.setItem('dealersExperience',dealersExperiences[clientLabel]);
            sessionStorage.setItem('mobileDeviceMode', dealersExperiences[clientLabel].includes('Mobile'));
            needReload = true;
          }
          else{
            console.log('clientLabel not found',clientLabel);
          }
      }
      return needReload;
    }

    var NeedReload = SetExperienceAndMobileDeviceMode();
    if (NeedReload) {
      location.reload();
    }
    var errorCounter = 0;
    var config = OktaUtil.getSignInWidgetConfig();
    Object.assign(config.i18n, ${JSON.stringify(config.i18n)});
    config.language = "${getLanguage()}";
    Object.assign(config.helpLinks, ${JSON.stringify(config.helpLinks)});
    Object.assign(config.features, ${JSON.stringify(config.features)});
    config.defaultCountryCode = ${JSON.stringify(config.defaultCountryCode)};
    config.customButtons = [
      {
        i18nKey: 'forgotUsername.title',
        className: 'link',
        click: function () {
          window.location.href = "${getOnpremHostname()}${configApp.forgetUserNamePath}";
        }
      },
    ];

    if (config.features.registration) {
      config.customButtons.push({
        i18nKey: 'registration.title',
        className: 'btn-registration',
        click: function () {
          window.location.href = "${getOnpremHostname()}${configApp.registrationPath}";
        }
      });
    }

    config.mobileDeviceMode = ${JSON.stringify(config.mobileDeviceMode)};
    config.useClassicEngine= ${JSON.stringify(config.useClassicEngine)};
    if (oktaSignIn != undefined) {
      oktaSignIn.remove();
    }
    var oktaSignIn = new OktaSignIn(config);
    var oktaSignInCompleteEvent = function (res) {
      if (window.logger) {
        if (res.status === 'SUCCESS') {
          window.logger.info("Authentication success. Username:" + res.user.profile.login);
        } else {
          window.logger.error("Authentication returned status: res.status");
        }
      }
      OktaUtil.completeLogin(res);
    }

    var oktaSignInErrorEvent = function (err) {
      if (window.logger) {
          window.logger.info("Authentication returned error:" + err.name + "," + err.message);
      }
    }

    oktaSignIn.renderEl(
      { el: '#okta-login-container' },
      oktaSignInCompleteEvent,
      oktaSignInErrorEvent
    );
    if (oktaSignIn.options.useClassicEngine) {
      oktaSignIn.before('success-redirect', async () => {
        // custom logic can go here. when the function resolves, execution will continue.
        window.logger.info("Authentication success. Username:" + oktaSignIn.router.appState.attributes.user.identifier);
      });
  }
    oktaSignIn.on('afterError', function (context, error) {
      let controller = "mfa-verify-password";

      // Erreur a l'entrer d'un MFA
      if (error.xhr.responseJSON.errorCode == "E0000069" && context.controller === "mfa-verify") {
        cookieStore.get("urlLogin").then( (response) => {
          window.location.replace( response.value);
        });
        return;
      }

      if (error.xhr.responseJSON.errorCode == "E0000011") {
        oktaSignIn.router.appState.attributes.transaction.data.stateToken = "";
      };

      if (oktaSignIn.options.useClassicEngine) {
        controller ="primary-auth";
      }
      if (context.controller === controller)
      {
        errorCounter += 1;
        if (oktaSignIn.options.useClassicEngine) {
          document.getElementById("okta-signin-password").value = "";
        }
        if (errorCounter >= 6) {
            waitForElm('.okta-form-infobox-error.infobox.infobox-error').then((elm) => {
            elm.lastChild.innerText = config.i18n[config.language].loginErrorCounter;
          });
        }
      }
    });

    function hideOrShowBasePrimaryAuth (context, isMobile, objID) {
      let controller = "primary-auth";
      if (oktaSignIn.options.useClassicEngine) {
        controller ="idp-discovery";
      }

      var obj = document.getElementById(objID);
      if (obj){
        if (context.controller === controller)
        {
          if ((!isMobile) || ("${configApp.businessEntityCode}" ==="14" && isMobile && objID ==="StyledInformativeMessageID" ))
          {
              obj.style.display = "block";
          }
        }
        else
        {
          obj.style.display = "none";
        }
      }
      return;
    }

    function updateTitle(context) {
      var StyledTitleId = document.getElementById("${StyledTitleId}");
      if (StyledTitleId) {
        if (context.controller === "idp-discovery")
        {
          errorCounter = 0;
          StyledTitleId.innerText = "${title}";
          if (oktaSignIn.options.useClassicEngine) {
            document.getElementsByClassName('o-form-input-name-remember')[0].parentElement.parentElement.style.display='${showRememberMeDisplay}';
            document.getElementsByClassName('primary-auth-container')[0].style.display='block';
            document.getElementById('help-links-container').style.display='none';
            document.querySelectorAll('[data-se="help-link"]')[0].setAttribute('style', 'display: block !important');
            document.getElementsByClassName('registration-container')[0].setAttribute('style', 'display: none !important');
          }

          setStyleAuthHeaderClassicEngine('none');
        }
        else if (context.controller === "primary-auth")
        {
          StyledTitleId.innerText = "${title}";
          if (oktaSignIn.options.useClassicEngine) {
            document.getElementsByClassName('o-form-input-name-remember')[0].parentElement.parentElement.style.display='${showRememberMeDisplay}';
            document.querySelectorAll('div.registration-container').forEach(function(e) { e.style.display='none' });
            document.getElementById('okta-signin-submit').setAttribute('value',oktaSignIn.options.i18n[oktaSignIn.options.language]['mfa.challenge.verify']);
            document.getElementById('help-links-container').style.display='block';
            document.getElementsByClassName('primary-auth-container')[0].style.display='none';
            document.querySelectorAll('[data-se="back-link"]').forEach(function(e) { e.setAttribute('style', 'display: block !important') });
            document.querySelectorAll('[data-se="help-link"]').forEach(function(e) { e.setAttribute('style', 'display: none !important') });
            document.getElementsByClassName('registration-container')[0].setAttribute('style', 'display: none !important');
          }

          setStyleAuthHeaderClassicEngine('none');
        }
        else if (context.formName === "select-authenticator-enroll" || context.formName === "select-authenticator-authenticate" || context.controller === "enroll-choices")
        {
          StyledTitleId.innerText = "${t('widgetTitleMultiFacteur')}";
        }
        else if (context.controller === "mfa-verify")
        {
          StyledTitleId.innerText = "${t('widgetTitleMultiFacteur')}";
          setStyleAuthHeaderClassicEngine('block');
        }
        else if (context.authenticatorKey === "okta_verify")
        {
          StyledTitleId.innerText = "${t('widgetTitleOktaVerify')}";
        }
        else if (context.authenticatorKey === "google_otp") {
          StyledTitleId.innerText = "${t('widgetTitleGoogleAuthenticator')}";
        }
        else if (context.controller === "enroll-totp") {
          StyledTitleId.innerText = "${t('widgetTitleAppAuthenticator')}";
        }
        else if (context.authenticatorKey === "phone_number" || typeof context.controller === "function")
        {
          StyledTitleId.innerText = "${t('widgetTitlePhoneAuthenticator')}";
        }
        else if (context.authenticatorKey === "webauthn") {
          StyledTitleId.innerText = "${t('widgetTitleBiometricAuthenticator')}";
        }
        else if (context.authenticatorKey === "okta_password") {
          StyledTitleId.innerText = "${title}";
        }
      }
      return;
    }

    function setStyleAuthHeaderClassicEngine(authHeaderDisplay) {
      if (oktaSignIn.options.useClassicEngine === true) {
        const authHeader = document.querySelector(".auth-header");
        authHeader.style.display = authHeaderDisplay;

        const oktaSignInHeader = document.querySelector(".okta-sign-in-header");
        oktaSignInHeader.style.borderBottomColor = '#fff';

        const beaconContainer = document.querySelector(".beacon-container");
        beaconContainer.style.top = '-52px';

        const authOrgLogo = document.querySelector(".auth-org-logo");
        authOrgLogo.style.display = 'none';
      }
    }

  function insertSeparators() {
    const separatorsToAdd = [
      ['.identifier-container', '.js-forgot-password', 'passwordUsernameSeparator'],  // Password section
      ['.okta-form-subtitle.o-form-explain', '.siw-main-view.keep-me-signed-in', 'keepMeSignedInSubtitleSeparator'], // Keep me signed in section
      ['.identifier-container', '.siw-main-view.select-enrollment-channel--okta_verify', 'oktaVerifyEnrollmentChannelSeparator'],  // Okta Verify - Options to choose
      ['.identifier-container', '.siw-main-view.enrollment-channel-data--okta_verify', 'oktaVerifyOptionsSeparator'],  // Okta Verify - Email & SMS
      ['.identifier-container', '.siw-main-view.enroll-poll--okta_verify', 'oktaVerifyValidationSeparator'],  // Okta Verify - Email & SMS confirmation
    ];

    separatorsToAdd.forEach((section) => {
      const locationTarget = document.querySelector(section[0]);
      const expectedSectionContainer = document.querySelector(section[1]);
      const hrId = section[2];

      if (expectedSectionContainer != null) {
        insertNodeAfter(locationTarget, createStyledHr("-32px", "-32px", "20px", "20px", hrId), true);
      }
    });
  }

  function setStyleInPhoneSection() {
    const title = document.querySelector("#okta-sign-in .siw-main-view .okta-form-subtitle");
    if (document.querySelector('.siw-main-view').classList.contains('challenge-authenticator--phone_number')) {
      var ValueSubmit = oktaSignIn.options.i18n[oktaSignIn.options.language]['mfa.challenge.VerifyCode'];
      document.querySelector('input.button.button-primary').setAttribute('value', ValueSubmit);
      insertNodeAfter(title,  createStyledHr("-32px", "-32px", "25px", "20px", "phoneChallengeUsernameSeparator"), true);
    } else {
      const body = document.querySelector('div.siw-main-view.authenticator-verification-data--phone_number');
      if (body) {
        const formContent = document.querySelector('.o-form-content');
        if (formContent) {
          insertNodeAfter(formContent, createStyledHr("-32px", "-32px", "40px", "-15px", "phoneVerificationUsernameSeparator"), true);
        }
      }
    }
  }

  function createStyledHr(marginLeft, marginRight, marginBottom, marginTop, id) {
    const newHrElement = document.createElement('hr');
    newHrElement.style = 'height: 1px; border-width: 0; color: gray; background-color: #d3d8de; margin-left: ' + marginLeft + '; margin-right: ' + marginRight + '; margin-bottom: ' + marginBottom + '; margin-top: ' + marginTop + ';';

    if (id) {
      newHrElement.id = id;
    }

    return newHrElement;
  }

  function insertNodeAfter(referenceNode, newNode, validateIfExists) {
    // Validate if needed to avoid inserting multiple times the element if it already exists
    if (validateIfExists === true && newNode) {

      if(newNode.id && document.querySelector("#" + newNode.id)) {
        return false;
      }
    }

    // Insert the node inside the parent
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    return true;
  }

  function setStyleInOktaSection() {
      // Sélectionne l'élément ayant la classe 'js-switchAuthenticator'
        const btnElement = document.querySelector('.js-switchAuthenticator');
      // Vérifie si l'élément est présent sur la page
        if (btnElement !== null) {
            var ValuebackToFactors = oktaSignIn.options.i18n[oktaSignIn.options.language]['mfa.backToFactors'];
            btnElement.textContent = ValuebackToFactors;
        }
      // Sélectionne l'élément ayant la classe 'okta_verify.mfa-verify'
      const siwMainView = document.querySelector('.siw-main-view.challenge-authenticator--okta_verify.mfa-verify');
      // Vérifie si la section de validation code okta est présente sur la page
      if (siwMainView !== null) {
      // Sélectionne l'élément ayant la classe 'identifier-container'
          const identifierContainer = document.querySelector('.identifier-container');
          const existingDivElement = document.querySelector('.okta-form-subtitle[data-se="o-form-explain"]');
              if (existingDivElement) {
      // Si l'élément div existe, le supprimer
              existingDivElement.remove();
          }
      // Crée un nouvel élément div et ajoute le code HTML à l'intérieur
          const divElement = document.createElement("div");
          divElement.innerHTML = '<div class="okta-form-subtitle" data-se="o-form-explain"><span class="no-translate"></span></div>';
      // Insère l'élément créé juste après l'élément ayant la classe 'identifier-container'
          identifierContainer.insertAdjacentElement("afterend", divElement);
          var ValueText = oktaSignIn.options.i18n[oktaSignIn.options.language]['enroll.totp.enterCode'];
          const spanElement = divElement.querySelector('.no-translate');
          spanElement.textContent = ValueText;
      // Recherche de l'élément div du bouton
          const btnElementSubmit = document.querySelector('.o-form-button-bar input[type="submit"]');
          if (btnElementSubmit) {
      // Si l'élément existe, changer sa valeur
          var ValueSubmit = oktaSignIn.options.i18n[oktaSignIn.options.language]['mfa.challenge.VerifyCode'];
          btnElementSubmit.value = ValueSubmit;
          }
      // Insère le separator
          insertNodeAfter(divElement, createStyledHr("-32px", "-32px", "20px", "15px", "oktaVerificationCodeSeparator"), true);
      }
  }

  function setPaddingbackBouton() {
    if (oktaSignIn.options.useClassicEngine === false) {
      const authContentInner = document.querySelector(".auth-content-inner");
      const switchAuthBtn = document.querySelector(".js-switchAuthenticator");
      if (switchAuthBtn) {
      switchAuthBtn.addEventListener("click", () => {
        authContentInner.style.paddingTop = null;
      });
     }
    }
  }

  function setCookie(name, value, expiration = undefined, domain = undefined, path = "/", addSecure = true)
  {
      var cookieValue = name + "=" + value;

      if (expiration) {
        cookieValue += ";expires=" + expiration;
      }

      if (domain) {
        cookieValue += ";domain=" + domain;
      }

      if (path) {
        cookieValue += ";path=" + path;
      }

      if (addSecure) {
        cookieValue += ";secure";
      }

      document.cookie = cookieValue;
  }

    function flushOktaStateToken (context) {
      let controller = "primary-auth";
      if (oktaSignIn.options.useClassicEngine) {
        controller ="idp-discovery";
      }
      if (context.controller === controller) {
        expireOktaStateToken();
      }
    }

    function setOktaStateToken(context) {
      if (context.controller === "custom-password-expired") {
        const btnTempPasswordLink = document.getElementsByClassName('button button-primary button-wide link-button')[0];
        if (btnTempPasswordLink != null) {
          btnTempPasswordLink.parentNode.replaceChild(btnTempPasswordLink.cloneNode(true), btnTempPasswordLink);
          const replacedBtnTempPasswordLink = document.getElementsByClassName('button button-primary button-wide link-button')[0];
          replacedBtnTempPasswordLink.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            window.location.hash = "#/change-password";
          });
        }
        let myDate = new Date();
        console.log(context.controller);
        myDate = new Date(myDate.getTime() + (5*60*1000));
        if (oktaSignIn.options.useClassicEngine) {
          cookieStore.get("oktaStateToken").then( (response) => {
            document.cookie = "awAccountManagementVersion=v1" + ";expires=" + myDate.toUTCString() + ";domain=.ia.ca;path=/;secure";
            document.cookie = "awAccountManagementVersion=v1" + ";expires=" + myDate.toUTCString() + ";domain=.iafg.net;path=/;secure";
            document.cookie = "awAccountManagementVersion=v1" + ";expires=" + myDate.toUTCString() + ";domain=.inalco.com;path=/;secure";
          })
        } else {
          const allDomains = [".ia.ca", ".iafg.net", ".inalco.com", ".iagestionprivee.ca", ".iaprivatewealth.ca"];
          const dealersExperienceDomains = [".ia.ca", ".iafg.net", ".inalco.com"];

          for(const domain of allDomains)
          {
            setCookie("oktaStateToken", sessionStorage.getItem("osw-oie-state-handle"), myDate.toUTCString(), domain);
            setCookie("awAccountManagementVersion", "v2", myDate.toUTCString(), domain);
            setCookie("username", oktaSignIn.getUser().identifier, myDate.toUTCString(), domain);
          }

          myDate.setFullYear(myDate.getFullYear() +1);

          for(const domain of dealersExperienceDomains)
          {
            setCookie("dealersExperience", sessionStorage.dealersExperience, myDate.toUTCString(), domain);
          }
        }
      }
    }

    function expireOktaStateToken(){
      const allDomains = [".ia.ca", ".iafg.net", ".inalco.com", ".iagestionprivee.ca", ".iaprivatewealth.ca"];

      let myDate = new Date();
      myDate = new Date(myDate.getTime() + (5*60*1000));
      myDate.setFullYear(myDate.getFullYear() - 1);
      for(const domain of allDomains)
      {
        setCookie("oktaStateToken", "aa", myDate.toUTCString(), domain);
      }
    }

    var observer = undefined;
    var observerConfig = { attributes: true } ;
    var observerCallback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "attributes") {
          if (mutation.attributeName === "disabled"){
            if (mutation.target.attributes.getNamedItem("disabled") === null) {
              document.getElementById("okta-signin-username").disabled = true;
            }
          }
        }
      }
    };

    oktaSignIn.on('afterRender', function (context) {
      console.log("afterRender");
      if (!oktaSignIn.options.useClassicEngine && context.controller === "primary-auth") {
        //ICI on efface le localstorage, car pour une raison X, des fois okta garde des reponses en memoire
        //ET brise le flow
        localStorage.clear();
      }
      hideOrShowBasePrimaryAuth(context, config.mobileDeviceMode, "${StyledInstabilityMessagesID}");
      hideOrShowBasePrimaryAuth(context, config.mobileDeviceMode, "${StyledInformativeMessageID}");
      updateTitle(context);
      flushOktaStateToken(context);
      setOktaStateToken(context);
      if  ("${configApp.businessEntityCode}" ==="14") {
        setPaddingbackBouton();
        insertSeparators();
        setStyleInPhoneSection();
        setStyleInOktaSection();
      }
      if (oktaSignIn.options.useClassicEngine && context.controller === "primary-auth") {
        const targetNode = document.getElementById("okta-signin-username");
        observer = new MutationObserver(observerCallback);
        observer.observe(targetNode, observerConfig);
      }
      else if ( observer != undefined)
      {
        observer.disconnect();
      }
      const dealersExperience = sessionStorage.getItem('dealersExperience') 
      if (dealersExperience != null){
        insertSeparators();
        if (!config.features.registration){
          const linkElement = document.getElementsByClassName("link default-custom-button link-button");
          if (linkElement.length == 1) {
            linkElement[0].style.borderBottom = '0px'
            linkElement[0].style.paddingBottom = '0px'
            linkElement[0].style.marginBottom = '0px'
          }
        }
      }
      if (!oktaSignIn.options.useClassicEngine) {
        if (context.formName === "select-authenticator-enroll" && context.controller === "enroll-choices"){
          //cacher le bouton retour a la page de connection
          document.getElementsByClassName("link js-cancel")[0].style.display="none";
          const mfaChoices = document.getElementsByClassName("authenticator-row clearfix");
          let findOneMfa = false;
          for (const mfaChoice of mfaChoices) {
            if (window.getComputedStyle(mfaChoice).display !== "none") 
            {
              findOneMfa = true;
              break;            
            }
          }
          if (!findOneMfa) {
            document.getElementsByClassName("button-primary button skip-all link-button")[0].click();
          }
        }
      }
      return;
    });
    var domain = "." + document.location.host.split('.').slice(-2).join('.');
    if ( oktaSignIn.options.useClassicEngine) {
      if (!document.location.href.includes("oauth2"))
      {
        document.cookie="urlLogin=" + document.location.href + "; expires=Session; path=/;domain=" + domain + ";secure=true;"
      };
    } else {
      document.cookie="urlLogin=" + document.location.href + "; expires=Session; path=/;domain=" + domain + ";secure=true;"
    };

    var mainLogo = document.querySelectorAll('[data-testid=MainLogo]')[0];
    mainLogo.addEventListener('click', (e) => {expireOktaStateToken()});
    `;
    const externalScript = document.createElement('script');
    externalScript.id = 'ExternalScriptForOktaLogin';
    externalScript.innerHTML = innerScript;
    externalScript.async = true;
    externalScript.type = 'text/javascript';
    document.body.append(externalScript);

    return () => {
      externalScript.remove();
    };
  }, [config, configApp, StyledInformativeMessageID, StyledInstabilityMessagesID, StyledTitleId, t, title, showRememberMeDisplay]);

  return (
    <>
      <WidgetGlobalStyles />
      <div id="okta-login-container"></div>
    </>
  );
};

export default SignIn;
